import { Component, Inject } from "@angular/core";
import { EquipmentsEntity } from "src/app/equipment/equipment";
import { MAT_DIALOG_DATA } from "@angular/material";
@Component({
  selector: "app-view-system-equipment",
  templateUrl: "./view-system-equipment.component.html",
  styleUrls: ["./view-system-equipment.component.css"],
})
export class ViewSystemEquipmentComponent {
  equipment: EquipmentsEntity;

  constructor(@Inject(MAT_DIALOG_DATA) private data: any) {}

  ngOnInit() {
    if (this.data) {
      this.equipment = this.data.equipment;
    }
  }
}
